import { withTranslation } from 'react-i18next'

import useCheckout from '@/features/Checkout/hooks/useCheckout'
import Button from '@/ui/Button'
import LazyImage from '@/ui/LazyImage'

import Modal from '../../../../ui/Modal'
import {
  RemoveProductActions,
  RemoveProductCaption,
  RemoveProductContent,
  RemoveProductImage,
  RemoveProductMessage,
  RemoveProductName,
  RemoveProductWrapper
} from './RemoveProductModal.styles'

const RemoveProductModal = ({ onClose, product, t }) => {
  const { name, activeVariant } = product
  const { removeFromCart } = useCheckout()
  const { additionalInfo } = product

  const handleRemove = () => {
    removeFromCart(product)
    onClose()
  }

  return (
    <Modal onClose={onClose}>
      <RemoveProductWrapper>
        <RemoveProductImage>
          <LazyImage src={product.imageUrl} />
        </RemoveProductImage>
        <RemoveProductContent>
          <RemoveProductMessage>{t('removeProductMessage')}</RemoveProductMessage>
          <RemoveProductName>{name}</RemoveProductName>
          {additionalInfo && <RemoveProductCaption>{additionalInfo}</RemoveProductCaption>}
          <RemoveProductActions>
            <Button variant="red" onClick={handleRemove} addRightMargin>
              {t('remove')}
            </Button>
            <Button variant="outline-dark" onClick={onClose}>
              {t('cancel')}
            </Button>
          </RemoveProductActions>
        </RemoveProductContent>
      </RemoveProductWrapper>
    </Modal>
  )
}

export default withTranslation()(RemoveProductModal)
